import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'

import LeftNavigationLink from './LeftNavigationLink'
import NotificationBadge from '../sitewide/NotificationBadge'
import * as NotificationActions from '../../state/actions/notifications'
import { logException } from '../../services/sentry'
import fetchApi from '../../services/fetchApi'

import AccountIcon from '../assets/AccountIcon'
import ScheduleIcon from '../assets/ScheduleIcon'
import MessagesIcon from '../assets/MessagesIcon'
import SettingsIcon from '../assets/SettingsIcon'
import DashboardIcon from '../assets/DashboardIcon'
import PatientsIcon from '../assets/PatientsIcon'
import ThreadLogoBig from '../assets/ThreadLogoBig'
import OpenchairIcon from '../assets/OpenchairIcon'
import CallLogIcon from '../assets/CallLogIcon'
import './styles.css'

class LeftMenu extends Component {
  static propTypes = {
    hasDSO: PropTypes.bool.isRequired,
    hasMarketing: PropTypes.bool.isRequired,
    hasNewPatientOS: PropTypes.bool.isRequired,
    hasPatientPortal: PropTypes.bool.isRequired,
    hasReminders: PropTypes.bool.isRequired,
    hasRemindersTier2: PropTypes.bool.isRequired,
    hasReviews: PropTypes.bool.isRequired,
    hasTextingOnly: PropTypes.bool.isRequired,
    hasTopsAlertsPlus: PropTypes.bool.isRequired,
    hasTopsRemindersPlus: PropTypes.bool.isRequired,
    hasScreenPop: PropTypes.bool.isRequired,
    hasMissedCallText: PropTypes.bool.isRequired,
    notifyConvos: PropTypes.func.isRequired,
    unseenConvoIds: PropTypes.instanceOf(Set).isRequired,
    practiceName: PropTypes.string.isRequired,
  }

  componentDidMount() {
    this.startPolling()
    window.addEventListener('beforeunload', this.onUnload)
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.onUnload)

    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  onUnload = () => {
    clearInterval(this.timer)
    this.timer = null
  }

  startPolling() {
    this.poll()
    const self = this
    setTimeout(() => {
      // poll notifications every hour. our websocket for messages will
      // be doing most of the work of updating the messages badge.
      self.timer = setInterval(self.poll.bind(self), 3600000)
    }, 1000)
  }

  async poll() {
    try {
      const { convo_ids: convoIds } = await fetchApi('/notifications', 'GET')
      this.props.notifyConvos(convoIds)
    } catch (error) {
      logException(error)
    }
  }

  render() {
    const {
      hasDSO,
      hasMarketing,
      hasNewPatientOS,
      hasPatientPortal,
      hasReminders,
      hasRemindersTier2,
      hasReviews,
      hasScreenPop,
      hasMissedCallText,
      hasTextingOnly,
      hasTopsAlertsPlus,
      hasTopsRemindersPlus,
      unseenConvoIds,
      practiceName,
    } = this.props

    const blastEnabled = ['Renton Canals'].includes(practiceName)
    const iconEnabled = {
      dashboard: hasReminders || hasReviews || hasTopsRemindersPlus,
      messages: hasReminders || hasTextingOnly,
      callLog: hasScreenPop,
      patients: hasReminders || hasScreenPop || blastEnabled,
      schedule: hasReminders || hasReviews,
      openchair: hasNewPatientOS,
      messageSettings: hasReminders || hasReviews || hasTextingOnly || hasNewPatientOS || hasMissedCallText,
      account: true,
    }
    return (
      <nav className="left-menu">
        <ul className="nav-links-list">
          <li className="nav-item" style={{ backgroundColor: '#2c2c2c' }}>
            <ThreadLogoBig height={'20px'} />
          </li>
          <LeftNavigationLink route="dashboard" disabled={!iconEnabled.dashboard}>
            <DashboardIcon />
            <div>Dashboard</div>
          </LeftNavigationLink>

          <LeftNavigationLink route="messages" disabled={!iconEnabled.messages}>
            {unseenConvoIds.size > 0 && (
              <NotificationBadge
                page={'Message'}
                numNotes={unseenConvoIds.size}
              />
            )}
            <MessagesIcon />
            <div>Messages</div>
          </LeftNavigationLink>

          <LeftNavigationLink route="calls" disabled={!iconEnabled.callLog}>
            <CallLogIcon />
            <div>Call Log</div>
          </LeftNavigationLink>

          <LeftNavigationLink
            route="patients"
            disabled={!iconEnabled.patients}
          >
            <PatientsIcon />
            <div>Patients</div>
          </LeftNavigationLink>

          <LeftNavigationLink route="schedule" disabled={!iconEnabled.schedule}>
            <ScheduleIcon />
            <div>Schedule</div>
          </LeftNavigationLink>

          <LeftNavigationLink route="openchair" disabled={!iconEnabled.openchair}>
            <OpenchairIcon />
            <div>Online Scheduling</div>
          </LeftNavigationLink>

          <LeftNavigationLink route="settings" disabled={!iconEnabled.messageSettings}>
            <SettingsIcon />
            <div>Message Settings</div>
          </LeftNavigationLink>
          <LeftNavigationLink route="account" disabled={!iconEnabled.account}>
            <AccountIcon />
            <div>Account</div>
          </LeftNavigationLink>
        </ul>
      </nav>
    )
  }
}

const mapStateToProps = ({
  notifications: { unseenConvoIds },
  account: {
    auth: {
      hasDSO,
      hasMarketing,
      hasNewPatientOS,
      hasPatientPortal,
      hasReminders,
      hasRemindersTier2,
      hasReviews,
      hasTextingOnly,
      hasTopsAlertsPlus,
      hasTopsRemindersPlus,
      hasScreenPop,
      hasMissedCallText,
    },
    user: { practiceName }
  },
}) => ({
  practiceName,
  hasDSO,
  hasMarketing,
  hasNewPatientOS,
  hasPatientPortal,
  hasReminders,
  hasRemindersTier2,
  hasReviews,
  hasTextingOnly,
  hasTopsAlertsPlus,
  hasTopsRemindersPlus,
  hasScreenPop,
  hasMissedCallText,
  unseenConvoIds,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...NotificationActions,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(LeftMenu)



// WEBPACK FOOTER //
// ./src/components/LeftMenu/index.js